import { render, staticRenderFns } from "./UnitListItem.vue?vue&type=template&id=635674c8"
import script from "./UnitListItem.vue?vue&type=script&lang=js"
export * from "./UnitListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports